import { VxApiSearchTool } from "../vx-api/base.vx-api.js";
import renderPackages from "./render.packages.js";
import { VXConnector } from "../vx-forms/helpers/vx-api.connector.js";

const initComparison = async () => {
  const ortusApi = window.ortus.api;
  const wrapper = document.querySelector(".js-comparison-wrapper");
  const filterForm = document.getElementById("filterForm");
  const pagingButton = document.getElementById("pagingButton");

  if (!filterForm) {
    console.info("No form supplied. Cancelling initialisation");
    return;
  }

  const { postCode, city, location } = getUrlParameters();
  if (filterForm.querySelector("#hiddenLocationInput").value === "") {
    filterForm.querySelector("#hiddenLocationInput").value = location;
  }

  const searchTool = await VxApiSearchTool({
    apiUrl: ortusApi,
    filterForm,
    pagingButton,
  });
  searchTool.tooling.onResultsUpdated(handleNewData);

  setSupplierAndTariffSelects(searchTool.comparisonData.benchmarkTariff);

  setTimeout(() => {
    handleNewData(searchTool.comparisonData);
    wrapper.querySelector("bc-loading-icon")?.remove();
  }, 1);
};

const setSupplierAndTariffSelects = async (benchmarkTariff) => {
  let productType = filterForm.querySelector("#hiddenProductType").value;
  let locationId = filterForm.querySelector("#hiddenLocationInput").value;
  let postCode = filterForm.querySelector("#postalCode").value;
  let usage = filterForm.querySelector("#hiddenUsageInput").value;

  const suppliers = await VXConnector().getBenchmarkSuppliers(productType, undefined, postCode, locationId, usage);

  let benchmarkSupplierId = null;
  let benchmarkTariffId = null;

  if (benchmarkTariff) {
    benchmarkSupplierId = benchmarkTariff.provider?.id;
    benchmarkTariffId = benchmarkTariff.id;
  }

  let supplierSelect = document.getElementById("previousSupplier");
  let tariffSelect = document.getElementById("previousTariff");

  supplierSelect.innerHTML = "";
  supplierSelect.innerHTML += `<option value="">Bitte wahle dein Anbieter aus</option>`;

  suppliers.forEach((supplier) => {
    let isSelected = supplier.id == benchmarkSupplierId ? "selected" : "";
    supplierSelect.innerHTML += `<option ${isSelected} value="${supplier.id}" data-tariffs='${JSON.stringify(supplier.tariffs)}' value="${supplier.name}">${supplier.name}</option>`;
  });

  supplierSelect.addEventListener("change", (e) => {
    let selectedSupplierId = e.target.value;
    if (selectedSupplierId) {
      let selectedSupplier = suppliers.find((s) => s.id === selectedSupplierId);
      tariffSelect.innerHTML = "";
      tariffSelect.innerHTML += `<option value="-1">Bitte wahle dein Tarif aus</option>`;

      selectedSupplier.tariffs.forEach((tariff) => {
        let isSelected = tariff.id == benchmarkTariffId ? "selected" : "";
        tariffSelect.innerHTML += `<option ${isSelected} value="${tariff.id}">${tariff.content.text}</option>`;
      });
    }
  });

  if (benchmarkSupplierId) {
    supplierSelect.dispatchEvent(new Event("change", { bubbles: true }));
  }
};

const getUrlParameters = () => {
  const params = Object.fromEntries(new URLSearchParams(location.search));
  return params;
};

const euroDisplay = (amount) => {
  if (isNaN(amount) && typeof amount === "string" && amount.indexOf(",") > -1) {
    amount = amount.replace(/\,/g, ".");
  }

  return parseFloat(amount).toFixed(2).replace(".", ",") + "&nbsp;&euro;";
};

const handleNewData = (searchData) => {
  let results, benchmarkTariff, formData;

  if (searchData) {
    ({ results, benchmarkTariff, formData } = searchData);
  }
  if (!results) {
    return;
  }

  const resultsContainer = document.getElementById("packageResults");

  if (benchmarkTariff) {
    const savingAmount = results[0]?.cost.savings.amount;
    const savingAmountRounded = Math.round(savingAmount);

    if (savingAmount > 20) {
      document.querySelector(".js-saving-banner__saving-amount").innerHTML = savingAmountRounded.toString() + "&nbsp;&euro;";
      document.querySelector(".js-saving-banner__benchmark-amount").innerHTML = euroDisplay(benchmarkTariff.totalCostInEuro);
      document.querySelector(".js-saving-banner__benchmark-provider").innerHTML = benchmarkTariff.providerName.content.text;
      document.querySelector(".js-saving-banner__benchmark-location").innerHTML = benchmarkTariff.tariff?.content.text;
      document.querySelector(".js-saving-banner__saving-header").removeAttribute("hidden");
      document.querySelector(".js-saving-banner__saving-subtext").removeAttribute("hidden");
      document.querySelector(".js-saving-banner__low-saving-message").setAttribute("hidden", true);
    } else {
      document.querySelector(".js-saving-banner__saving-header").setAttribute("hidden", true);
      document.querySelector(".js-saving-banner__saving-subtext").setAttribute("hidden", true);
      document.querySelector(".js-saving-banner__low-saving-message").removeAttribute("hidden");
    }
    document.querySelector(".js-saving-banner").removeAttribute("hidden");
    if (!benchmarkTariff.providerName.content.text) {
      document.querySelector(".js-meta-data--default-supplier").setAttribute("hidden", true);
      document.querySelector(".js-meta-data--heatingelectricity-default-provider").setAttribute("hidden", true);
    } else {
      document.querySelector(".js-meta-data--default-supplier").removeAttribute("hidden");
    }
    document.querySelector(".js-meta-data--supplier").innerHTML = benchmarkTariff.providerName.content.text;
    document.querySelector(".js-meta-data--tariff").innerHTML = benchmarkTariff.tariffName.content.text;
  }

  const currentCity = document.querySelector("#selectedAddress")?.value || window.ortus.preselectedValues?.city;
  if (currentCity) {
    document.querySelector(".js-meta-data--city").innerHTML = currentCity;
  }
  if (window.ortus.preselectedValues?.energyArea) {
    let energyArea = window.ortus.preselectedValues.energyArea;
    if (energyArea === "heating") {
    } else if (energyArea === "green") {
      document.querySelector('input[name="isGreenElectricity"][value="true"]').checked = true;
    }
  }
  const page = parseInt(formData.page);
  const pageSize = parseInt(formData.pageSize);

  if (page == 1) {
    resultsContainer.innerHTML = "";
  }

  let searchResultsData = {
    data: results,
    target: resultsContainer,
    formData,
  };

  Array.from(document.querySelectorAll("bc-loading-icon"))?.forEach((icon) => icon.remove());
  renderPackages(searchResultsData);
};

export { initComparison };
